import React, { FC } from 'react'
import { BasicModal } from './index'
import { CautionHeadline, Description } from 'components/Typography'
import { Spacer } from 'components/Utility'
import { CautionButton, GreyButton } from 'components/Button'
import { FlexRow } from 'components/Flex'

type Props = {
  actionLabel?: string
  align?: 'center' | 'left' | 'right'
  cancelLabel: string
  caution: string
  closeModal: () => void
  description?: string
  open: boolean
  onClickAction?: () => void
  onClickCancel: () => void
}

const CautionModal: FC<Props> = (props) => {
  const {
    actionLabel,
    align = 'left',
    cancelLabel,
    caution,
    closeModal,
    description,
    open,
    onClickAction,
    onClickCancel,
  } = props

  return (
    <BasicModal open={open} closeModal={closeModal}>
      <CautionHeadline align={align} caution={caution} />
      {description && (
        <>
          <Spacer size={12} />
          <Description description={description} />
        </>
      )}
      <Spacer size={24} />
      <FlexRow justifyContent={'center'}>
        <GreyButton label={cancelLabel} onClick={onClickCancel} size={'small'} type={'outlined'} />
        <Spacer size={16} />
        {onClickAction && actionLabel && <CautionButton label={actionLabel} onClick={onClickAction} size={'small'} />}
      </FlexRow>
    </BasicModal>
  )
}

export default CautionModal
